import Vue from 'vue'
import Vuex from 'vuex'
import booking from './booking'
import createPersistedState from "vuex-persistedstate"
import SecureLS from "secure-ls";
const ls = new SecureLS({ isCompression: false });

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        ports: [],
        tickets: {
            oneway: 'One way',
            return: 'Return',
            daytrip: 'Day trip',
        },
    },
    getters: {
        getPortById: (state) => (id) => {
            return state.ports.find(port => port.id == id)
        },
    },
    mutations: {
        setPorts(state, ports) {
            state.ports = ports
        },
    },
    actions: {

    },
    modules: {
        booking: booking,
    },
    plugins: [
        createPersistedState({
            storage: {
                getItem: (key) => ls.get(key),
                setItem: (key, value) => ls.set(key, value),
                removeItem: (key) => ls.remove(key),
            },
        }),
    ],
})